export default __webpack_public_path__ + "static/media/titanium.a815239b.JPG";